import React from 'react';

/**
 * Badge component indicating a task is court-mandated.
 * Shows a gavel icon with tooltip containing the mandate reference.
 */

interface CourtMandatedBadgeProps {
  mandateReference?: string | null;
  statuteReference?: string | null;
}

const CourtMandatedBadge: React.FC<CourtMandatedBadgeProps> = ({
  mandateReference,
  statuteReference,
}) => {
  const tooltip = [
    'Court-mandated task',
    mandateReference ? `Mandate: ${mandateReference}` : null,
    statuteReference ? `Statute: ${statuteReference}` : null,
  ]
    .filter(Boolean)
    .join('\n');

  return (
    <span
      title={tooltip}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 cursor-help"
    >
      {/* Gavel / Scale icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-3.5 w-3.5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.715-5.349L10 6.022V16h3a1 1 0 110 2H7a1 1 0 110-2h3V6.022L6.237 7.582l1.715 5.349a1 1 0 01-.285 1.05A3.989 3.989 0 015 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.789l1.599.799L9 4.323V3a1 1 0 011-1z"
          clipRule="evenodd"
        />
      </svg>
      Mandated
    </span>
  );
};

export default CourtMandatedBadge;
